import { Prisma, Role } from "@prisma/client";
import { buyableItemValuesForEventName } from "./buyable-item.types";
import { MethodPayment } from "./payment.types";
import { PaginatedResponse } from "./utils.types";

export const paymentHistoryStatuses = ["toValidate", "inReview", "accepted", "refused"] as const;

export type PaymentHistoryStatus = (typeof paymentHistoryStatuses)[number];

export type PaymentHistoryFilters = {
  searchText?: string;
  status: PaymentHistoryStatus;
  paymentType?: MethodPayment;
  professionalRole?: Role;
  issueDateFrom?: string;
  issueDateTo?: string;
};

export const paymentHistoryValues = Prisma.validator<Prisma.OrderDefaultArgs>()({
  select: {
    id: true,
    reference: true,
    total: true,
    status: true,
    createdAt: true,
    lastAcceptedCreditNoteCreatedAt: true,
    onlineDetails: {
      select: {
        billingFirstName: true,
        billingLastName: true,
        billingBusinessName: true,
        role: true,
        user: {
          select: {
            id: true,
            email: true,
            roles: true,
            firstName: true,
            lastName: true,
            businessName: true,
          },
        },
      },
    },
    onlineCardPayment: {
      select: {
        card: true,
        callNumber: true,
        authorizationNumber: true,
      },
    },
    proPaymentMethod: {
      select: {
        paymentType: true,
        bankDraftDueDate: true,
      },
    },
    orderItems: {
      take: 1,
      select: {
        buyableItem: buyableItemValuesForEventName,
      },
    },
  },
});

export type PaymentHistoryOrder = Prisma.OrderGetPayload<typeof paymentHistoryValues>;

export type PaymentHistoryListItem = {
  id: string;
  professionalName: string;
  eventName: string | null;
  paymentType: MethodPayment;
  bankDraftDueDate: string | null;
  professionalRole: Role | null;
  amount: number;
  issueDate: string;
  creditNoteCreatedAt: string | null;
};

export type PaymentHistoryResponse = PaginatedResponse<PaymentHistoryListItem>;

export type UpdatePaymentStatusPayload = {
  orderId: string;
  status: "accepted" | "refused" | "canceled";
};

export const BANK_DRAFT_CLEARANCE_DAYS = 15;
